import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { API } from "@/lib/brand";
import PostCard from "./PostCard";

/**
 * "From the Journal" — a small strip of the latest N published posts,
 * intended for the Home page below the hero.
 */
export default function HomeJournalStrip({ limit = 2 }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API}/journal/posts?limit=${limit}`);
        const data = res.ok ? await res.json() : [];
        if (!cancelled) setPosts(Array.isArray(data) ? data : []);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [limit]);

  if (loading || posts.length === 0) return null;

  return (
    <section
      className="max-w-6xl mx-auto px-6 md:px-8 py-16 md:py-20"
      data-testid="home-journal-strip"
    >
      <div className="flex items-end justify-between mb-8 md:mb-10 flex-wrap gap-4">
        <div>
          <div className="eyebrow mb-2">From the Journal</div>
          <h2 className="font-display text-3xl md:text-4xl text-ink leading-tight max-w-2xl">
            Practical notes on wealth, protection & planning.
          </h2>
        </div>
        <Link
          to="/journal"
          className="link-brass inline-flex items-center gap-1.5 text-[14px]"
          data-testid="home-journal-all"
        >
          Read all posts <ArrowRight size={14} />
        </Link>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {posts.map((p) => (
          <PostCard key={p.id} post={p} testId={`home-post-${p.slug}`} />
        ))}
      </div>
    </section>
  );
}
